<template>
  <v-banner class="impersonation-banner bg-warning" lines="one">
    <template v-slot:prepend>
      <v-icon color="white" size="24">mdi-account-switch</v-icon>
    </template>
    <v-banner-text class="text-white font-weight-medium">
      Mode test actif — connecté en tant que <strong>{{ targetUid }}</strong>
    </v-banner-text>
    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="$emit('restore-admin-session')">
        <v-icon start>mdi-account-arrow-left</v-icon>
        Revenir à l'admin
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
  export default {
    name: "ImpersonationBanner",
    props: {
      targetUid: {
        type: String,
        default: "",
      },
    },
    emits: ["restore-admin-session"],
  };
</script>

<style scoped>
  .impersonation-banner {
    width: 100%;
  }
</style>
